import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class ActivateGuard implements CanActivate {
  canActivate() {
    return true;
  }
}
